import operatorApiFetch from './apiService';

const supplierService = {
  getRecords: async (params = {}) => {
    const res = await operatorApiFetch('suppliers/get_records', { method: 'POST', body: params });
    return res.json();
  },

  getIds: async (params = {}) => {
    const res = await operatorApiFetch('suppliers/get_ids', { method: 'POST', body: params });
    return res.json();
  },

  get: async (id) => {
    const res = await operatorApiFetch(`suppliers/${id}`, { method: 'GET' });
    return res.json();
  },

  create: async (data) => {
    const res = await operatorApiFetch('suppliers', { method: 'POST', body: { supplier: data } });
    return res.json();
  },

  update: async (id, data) => {
    const res = await operatorApiFetch(`suppliers/${id}`, { method: 'PUT', body: { supplier: data } });
    return res.json();
  },

  destroy: async (id) => {
    const res = await operatorApiFetch(`suppliers/${id}`, { method: 'DELETE' });
    return res.json();
  },
};

export { supplierService };
export default supplierService;
